import React from 'react'
import { Grid, Cell } from "react-mdl";
import './style.css'

export default class RareAffixes extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            prefixes: props.prefixes,
            suffixes: props.suffixes
        };
    }

    renderPrefixes() {
        return (
            <div>
            { (this.state.prefixes.length > 0) ?
                <div>
                    <h4>Prefixes</h4>
                    {
                        this.state.prefixes.map((prefix) =>
                        <span className="rare-prefix">{prefix}</span>
                        )
                    }
                </div>
                :
                <div>
                    <h4>No prefixes</h4>
                </div>
            }
            </div>
        );
    }

    renderSuffixes() {
        return (
            <div>
            { (this.state.suffixes.length > 0) ?
                <div>
                    <h4>Suffixes</h4>
                    {
                        this.state.suffixes.map((suffix) =>
                        <span className="rare-suffix">{suffix}</span>
                        )
                    }
                </div>
                :
                <div>
                    <h4>No suffixes</h4>
                </div>
            }
            </div>
        );
    }

    render() {
        return (
            <Grid className='rare-affixes'>
                <h3>Affixes</h3>
                <Cell col={6}>{this.renderPrefixes()}</Cell>
                <Cell col={6}>{this.renderSuffixes()}</Cell>
            </Grid>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/character/item/rare-affixes/index.js